
import { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import LeadConsent from '@/interfaces/leadConsent.interface';
import { MINDWORKING_REDIRECT_TYPES } from '@/constants/mindworkingRedirectTypes.const';
import oPropertyFavoriteOverlay from '@/components/organisms/property/PropertyFavoriteOverlay.vue';
import { property } from 'lodash';

interface ITexts {
    headline: string;
    description: string;
    savedHeadline: string;
    savedDescription: string;
    receiptLinkToProfileName: string;
    receiptLinkToProfileUrl: string;
    loginText: string;
}

export default {
    components: {
        oPropertyFavoriteOverlay,
    },
    props: {
        redirected: {
            type: Boolean as PropType<boolean>,
            required: true,
            default: () => false,
        },

        redirectedFrom: {
            type: String as PropType<string>,
            required: true,
            default: () => '',
        },
        texts: {
            type: Object as PropType<ITexts>,
            default: () => ({
                headline: '',
                description: '',
                savedHeadline: '',
                savedDescription: '',
                receiptLinkToProfileName: '',
                receiptLinkToProfileUrl: '',
                loginText: '',
            }),
        },
        consent: {
            type: Object as PropType<LeadConsent>,
            default: () => ({
                id: '',
                purposeText: '',
            }),
        },
    },

    mounted() {
        if (
            this.redirected &&
            this.redirectedFrom ===
                MINDWORKING_REDIRECT_TYPES.MW_FAVORITE_PROPERTY
        ) {
            this.$store.dispatch('modal/open', 'favoriteProperty');
        }
    },

    computed: {
        ...mapGetters({
            currentPanel: 'favoriteProperty/currentPanel',
            modalShow: 'modal/show',
            modalType: 'modal/type',
        }),

        showSearchFavoritePropertyOverlay(): boolean {
            return this.modalShow && this.modalType === 'favoriteProperty';
        },
    },

    methods: {
        ...mapActions({
            setCurrentPanel: 'favoriteProperty/setCurrentPanel',
            open: 'favoriteProperty/open',
        }),
    },
};
